import React from "react";
import { PageHeaderSection } from "../components";
import { Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import config from "../config/Main.json"

const Privacy: React.FunctionComponent = () => {
  const { t } = useTranslation("privacy");

  const subTitleStyle: React.CSSProperties = {
    fontSize: "2rem",
    fontWeight: 300,
    margin: "calc(2rem - .14286em) 0 1rem",
    color: "#000000de",
    fontFamily: "Avenir Next Codensed Ultralight",
  };

  const contentStyle: React.CSSProperties = {
    fontFamily: "Avenir Next Codensed Regular",
    fontSize: "1.2rem",
    fontWeight: 200,
    color: "#342714"
  };

  return (
    <Container>
      <PageHeaderSection
        id={"section_start"}
        headline={t("headline")}
        subheadline={t("headline-information")}
        content={<p style={{ ...contentStyle, textAlign: "left" }}>{t("information")}</p>}
      />
      <div style={contentStyle}>
        <h2 style={subTitleStyle}>{t("elevation-headline")}</h2>
        <p>{t("elevation-content-01")}</p>
        <p>{t("elevation-content-02")}</p>
        <p>{t("elevation-content-03")}</p>
        <h2 style={subTitleStyle}>{t("headline-responsible")}</h2>
        <p>{t("responsible-content")}</p>
        <p>{config.company}</p>
        <p>{config.streetAddress}</p>
        <p>{config.postalCode} {config.locality}</p>
        <p><strong>{t("page-about-represented")}</strong></p>
        <p>{config.businessOrganisation}</p>
        <h2 style={subTitleStyle}>{t("headline-protection_officer")}</h2>
        <p>{t("protection_officer-content", { givenname: config.protectionOfficer.givenname, surname: config.protectionOfficer.surname, streetAddress: config.protectionOfficer.streetAddress, postalCode: config.protectionOfficer.postalCode, location: config.protectionOfficer.location })}</p>
        <h2 style={subTitleStyle}>{t("headline-hosting")}</h2>
        <p>{t("hosting-content")}</p>
        <h2 style={subTitleStyle}>{t("collection-headline")}</h2>
        <p>{t("collection-content-01")}</p>
        <p>
          <ul>
            <li>{t("collection-content-ul-01")}</li>
            <li>{t("collection-content-ul-02")}</li>
            <li>{t("collection-content-ul-03")}</li>
            <li>{t("collection-content-ul-04")}</li>
            <li>{t("collection-content-ul-05")}</li>
            <li>{t("collection-content-ul-06")}</li>
            <li>{t("collection-content-ul-07")}</li>
          </ul>
        </p>
        <p>{t("collection-content-02")}</p>
        <h2 style={subTitleStyle}>{t("contact-headline")}</h2>
        <p>{t("contact-content")}</p>
        <h2 style={subTitleStyle}>{t("mail-headline")}</h2>
        <p>{t("mail-content")}</p>
        <h2 style={subTitleStyle}>{t("phone-headline")}</h2>
        <p>{t("phone-content")}</p>
        <h2 style={subTitleStyle}>{t("whatsapp-headline")}</h2>
        <p>{t("whatsapp-content_01")}</p>
        <p>{t("whatsapp-content_02")}</p>
        <h2 style={subTitleStyle}>{t("order-headline")}</h2>
        <p>{t("order-content")}</p>
        <p>{t("order-content-01")}</p>
        <p>{t("order-content-01-dhl")}</p>
        <p>{t("order-content-01-dpd")}</p>
        <p>{t("order-content-01-ups")}</p>
        <p>{t("order-content-02")}</p>
        <p>{t("order-content-02-paypal")}</p>
        <h2 style={subTitleStyle}>{t("newsletter-headline")}</h2>
        <p>{t("newsletter-content")}</p>
        <p>{t("newsletter-content-01")}</p>
        <h2 style={subTitleStyle}>{t("guest-registration-headline")}</h2>
        <p>{t("guest-registration-content")}</p>
        <p>{t("guest-registration-content-01")}</p>
        <p>{t("guest-registration-content-02")}</p>
        <p>{t("guest-registration-content-03")}</p>
        <h2 style={subTitleStyle}>{t("carrier-headline")}</h2>
        <p>{t("carrier-content_01")}</p>
        <p>{t("carrier-content_02")}</p>
        <p>{t("carrier-content_03")}</p>
        <p>{t("carrier-content_04")}</p>
        <p>{t("carrier-content_05")}</p>
        <p>{t("carrier-content_06")}</p>
        <p>{t("carrier-content_07")}</p>
        <p>{t("carrier-content_08")}</p>
        <p>{t("carrier-content_09")}</p>
        <h2 style={subTitleStyle}>{t("plugins-headline")}</h2>
        <p>{t("plugins-content")}</p>
        <p>{t("plugins-content-01")}</p>
        <p>{t("plugins-content-maps")}</p>
      </div>
    </Container>
  );
}

export default Privacy;
